import './Navbar.css';
import React, { useState, useEffect } from 'react';
import logoLight from '../assets/images/navbar_logo.png';
import logoDark from '../assets/images/navbar_logo_blue.png';

const Navbar = ({ sections }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  // ESTADO DO SCROLLSPY: Guarda o slug da seção ativa na tela
  const [activeSection, setActiveSection] = useState('');

  // 1. EFEITO UNIFICADO: Controla a cor do Navbar e limpa o menu no topo do site
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);

      // CORREÇÃO DO 2º PROBLEMA: Se o usuário estiver no topo do site (Hero), limpa qualquer destaque
      if (window.scrollY < 100) {
        setActiveSection('');
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 2. NOVO EFEITO AJUSTADO: IntersectionObserver calibrado para o Scrollspy
  useEffect(() => {
    const slugs = sections
      .filter(section => section.component_type !== 'hero' && section.slug !== 'home')
      .map(section => section.slug);

    const observerOptions = {
      root: null,
      // CORREÇÃO DO 1º PROBLEMA: Ajustamos as margens para -10% no topo e -45% na base. 
      // Isso cria uma "linha de gatilho" perfeita no terço superior da tela.
      rootMargin: '-10% 0px -45% 0px',
      threshold: 0.05 // Dispara mesmo se apenas 5% da seção encostar na área de foco
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    slugs.forEach((slug) => {
      const element = document.getElementById(slug);
      if (element) observer.observe(element);
    });

    return () => {
      slugs.forEach((slug) => {
        const element = document.getElementById(slug);
        if (element) observer.unobserve(element);
      });
    };
  }, [sections]);

  // FUNÇÃO HAMBURGUER
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // FUNÇÃO DO ELÁSTICO
  const elasticScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (!target) return;

    setIsMenuOpen(false); 
    document.documentElement.style.scrollBehavior = 'auto';

    const targetHeaderOffset = 70;
    const elementPosition = target.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - targetHeaderOffset;
    const startPosition = window.scrollY;
    const distance = offsetPosition - startPosition;
    
    const duration = 1500; 
    let startTime = null;

    const motorEasing = (t) => {
      if (t < 0.4) {
        return t * (0.20 / 0.4); 
      } else {
        const t2 = (t - 0.4) / 0.6;
        const elasticFactor = 1 - Math.pow(1 - t2, 3); 
        return 0.20 + (0.80 * elasticFactor);
      }
    };

    const step = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const easeValue = motorEasing(progress);
      window.scrollTo(0, startPosition + (distance * easeValue));

      if (elapsed < duration) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };

  return (
    <> 
      {!isScrolled && (
        <div 
          className={`blur-overlay ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          style={{ zIndex: 1040 }}
        ></div>
      )}

      <nav 
        className={`navbar navbar-expand-lg navbar-dark fixed-top ${isScrolled ? 'navbar-scrolled shadow' : 'navbar-transparent'}`}
        style={{ zIndex: 1050 }}
      >
        <div className="container">
          <a 
            className="navbar-brand" 
            href="#top" 
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
              setActiveSection(''); // Limpa a seleção ativa ao voltar ao topo (Hero)
            }}
            style={{ cursor: 'pointer' }}
          >
            <img 
              src={(isScrolled || isMenuOpen) ? logoLight : logoDark} 
              alt="Jurerê Blue" 
              className="navbar-logo" 
            />
          </a>
          
          <button className="navbar-toggler border-0" type="button" onClick={toggleMenu}>
            <span className="navbar-toggler-icon"></span>
          </button>
          
          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav ms-lg-5">
              {sections.filter(section => section.component_type !== 'hero' && section.slug !== 'home').map(section => (
                <li className="nav-item" key={section.id}>
                  <a 
                    // INJEÇÃO DA CLASSE ACTIVE: Compara o slug atual com a seção no visor do usuário
                    className={`fonte-terciaria nav-link ${activeSection === section.slug ? 'active' : ''}`} 
                    href={`#${section.slug}`}
                    onClick={(e) => elasticScroll(e, section.slug)}
                    style={{ cursor: 'pointer' }}
                  >
                    {section.navbar_title || section.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </> 
  );
};

export default Navbar;